import { useEffect, useMemo } from 'react'

import { type ILeadDetail } from '@user/store/lead'
import { getLeadStatus } from './utils'
import { useAppDispatch } from '@user/store/hooks'
import { useSelectFunnelStagesByType } from '@user/store/salesFunnel'
import { useAddContact } from '@user/components/DetailPages/sections/Contacts'
import {
  searchExistingAppointments,
  useSchedulingEnabled,
} from '@user/store/scheduling'
import { useSchedulingVisibility } from '@user/store/closingRequirements'

export function useData(props: { detail: ILeadDetail }) {
  const {
    detail: {
      id,
      salesFunnelId,
      primaryContact,
      scheduleSettings,
      salesFunnelStageId,
      externalLocationId,
      locations,
    },
  } = props

  const appDispatch = useAppDispatch()

  const funnelStages = useSelectFunnelStagesByType(salesFunnelId, 'Lead')

  const leadStatus = useMemo(() => {
    const result = getLeadStatus(funnelStages, salesFunnelStageId)
    return result
  }, [salesFunnelStageId, funnelStages])

  const entityName = useMemo(() => {
    const { firstName, lastName, company } = primaryContact
    const fullName = `${firstName} ${lastName}`
    return fullName.trim().length > 0 ? fullName : company
  }, [primaryContact])

  const addContact = useAddContact()

  const leadMatched = Boolean(externalLocationId)

  const primaryContactMatched = Boolean(primaryContact.externalLinkId)

  const schedulingEnabled = useSchedulingEnabled()

  const schedulingVisible = useSchedulingVisibility(scheduleSettings)

  const searchAppts = schedulingEnabled && schedulingVisible

  useEffect(() => {
    if (searchAppts) {
      appDispatch(
        searchExistingAppointments({
          entityIds: [id],
          entityType: 1,
        }),
      )
    }
  }, [appDispatch, id, searchAppts])

  return {
    ...addContact,
    entityName,
    leadStatus,
    leadMatched,
    primaryContactMatched,
    locations,
  }
}
